import React from 'react';
import { VerificationStatus } from '../../types/experience';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'secondary' | 'success' | 'warning' | 'danger';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-blue-100 text-blue-800 border-transparent',
    outline: 'text-gray-800 border-gray-300',
    secondary: 'bg-gray-100 text-gray-800 border-transparent',
    success: 'bg-green-100 text-green-800 border-transparent',
    warning: 'bg-yellow-100 text-yellow-800 border-transparent',
    danger: 'bg-red-100 text-red-800 border-transparent'
  };
  return <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-bold border ${variants[variant]} ${className}`} data-id="element-326">
      {children}
    </span>;
}
export function StatusBadge({
  status
}: {
  status: VerificationStatus;
}) {
  switch (status) {
    case 'verified':
      return <Badge variant="success" data-id="element-327">Verified</Badge>;
    case 'flagged':
      return <Badge variant="danger" data-id="element-328">Flagged</Badge>;
    case 'skipped':
      return <Badge variant="secondary" data-id="element-329">Skipped</Badge>;
    case 'pending':
    default:
      return <Badge variant="outline" data-id="element-330">Pending</Badge>;
  }
}
export function TierBadge({
  tier
}: {
  tier: string;
}) {
  let variant: 'default' | 'success' | 'warning' | 'secondary' = 'default';
  if (tier === '5+') variant = 'success';else if (tier === '3-4') variant = 'default';else if (tier === '1' || tier === '2') variant = 'warning';else variant = 'secondary';
  return <Badge variant={variant} data-id="element-331">Tier {tier}</Badge>;
}